import TrelloClient from "trello";
import { AuthContext, apiTokenService } from "@harvestr-api/common";
import { gqlApitokenWithLinksFragment } from "@harvestr-api/models";
import * as APITOKEN_FRAGMENT from "../fragments/apitoken.graphql";

export const getTrelloToken = async (ctx: AuthContext) => {
    const tokens = <gqlApitokenWithLinksFragment[]>(
        await apiTokenService
            .getApiTokens({ where: { source: "TRELLO" } }, ctx)
            .$fragment(APITOKEN_FRAGMENT)
    );
    return tokens.length ? tokens[0]?.token : undefined;
};

export const getTrelloAuth = async (
    ctx: AuthContext,
    gotTokenAlready?: string
) => {
    let token;
    if (!gotTokenAlready) {
        token = await getTrelloToken(ctx);
    } else {
        token = gotTokenAlready;
    }

    if (token === undefined) {
        throw new Error("getTrelloAuth() : Not authorized");
    }
    return {
        token,
        key: process.env.TRELLO_KEY
    };
};

export const getTrelloClient = async (
    ctx: AuthContext,
    gotTokenAlready?: any
) => {
    const token = gotTokenAlready || (await getTrelloToken(ctx));

    return new TrelloClient(process.env.TRELLO_KEY, token);
};
